module.exports = __webpack_public_path__ + "static/media/p3.2a1da5ec.jpg";